// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4f79e58","453":"d963bdad","455":"d7fc885f"}[chunkId] + ".chunk.js";
};